import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {AttributeInterpreter, AttributeType, ConfigurationInterpreter, DecisionKind} from '@viamedici-spc/configurator-ts';

import {SpcBaseAttribute} from './spcBaseAttribute';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';

import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';

@customElement('spc-choice-attribute')
export class SpcChoiceAttribute extends SpcBaseAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {
				position: relative;
			}
			.listSelect .values {
				flex-flow: column;
			}
			.attribute {
				break-inside: avoid;
			}
		`];

	stateChanged(state) {
		super.stateChanged(state);
		if (this.spcConfiguration) {
			//this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				this.values = Array.from(this.attribute.values?.values())
					.filter(v => !this.excludedValues?.includes(v.id))
					.filter(v => !v.isPossibleDecisionStatesImmutable);
					//.sort((a, b) => this.getProductDataForValue(a.id)?.displaySequenceUi - this.getProductDataForValue(b.id)?.displaySequenceUi);
			} else {
				console.error('Choice attribute not found with id', this.attributeId, this.spcConfiguration);
			}
		}
	}

	async resetDecision() {
		const resetDecisions = [...this.attribute.values.values()]
			.filter(v => v.decision !== null && v.decision.kind === DecisionKind.Explicit)
			.map(v => ({
				type: AttributeType.Choice,
				attributeId: this.attribute.id,
				choiceValueId: v.id,
				state: null,
			}));
		if (resetDecisions.length > 0) {
			await this.session.makeManyDecisions(resetDecisions, {type: 'KeepExistingDecisions'});
		}
	}

	render() {
		if (!this.values) return null;
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied(), listSelect: this.displayStyle === 'listSelect'})}">
				<div class="title">
					<span class="label">
						<trans-label .showIdWhenMissing=${true} key="${this.attribute.key}" context="F" title="${this.attribute.key}"></trans-label>
					</span>
					<div class="tools">
						${when(this.hasFeatureDescription(), () => html`
							<button class='tools_button' @click="${this.openModal}">${info}</button>
						`)}
						<div class="status">
							${when(!this.isMandatory(), () => html`
								<button class='tools_button reset' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
							`)}
							<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
						</div>
					</div>
				</div>
				<div class="values">
					${repeat(this.values
							.sort(this.getCompareFunction())
							.slice(0, 200),
						(value) => value.id,
						(value) => html`
							<spc-choice-value
								.attribute=${this.attribute}
								.displayStyle=${this.displayStyle}
								.instance=${this.instance}
								.value=${value}
								.hideWhenDisabled=${this.hideDisabledValues}>
							</spc-choice-value>
						`)}
				</div>
			</div>

		`;
	}
}
